import mapProps from '../scripts/utils/map-props';
import Popconfirm from './popconfirm';

export default mapProps(
  [
    'show',
  ],
  {
    model: {
      prop: 'show',
      event: 'change',
    },
  }
)(Popconfirm);
